// extracted by mini-css-extract-plugin
export var button = "_1t-0";
export var buttonContent = "_1t-e";
export var buttonGroup = "_1t-c";
export var dontRestrainIconWidth = "_1t-a";
export var dropdownButton = "_1t-b";
export var iconContainer = "_1t-9";
export var lg = "_1t-4";
export var md = "_1t-3";
export var pending = "_1t-f";
export var sm = "_1t-2";
export var spinner = "_1t-d";
export var squared = "_1t-8";
export var wrapText = "_1t-g";
export var xl = "_1t-5";
export var xs = "_1t-1";
export var xxl = "_1t-6";
export var xxxl = "_1t-7";